import { ModelService } from 'services/model/model.service';
import { call, put, takeEvery } from 'typed-redux-saga';

import { modelAction } from '../actions/model';
import { modelConstant } from '../actionTypes';

const fetchModels = function* () {
  try {
    const response = yield* call(() => ModelService.getModels());
    yield* put(modelAction.fetchModelsSuccess(response.data));
  } catch (error) {
    const errorMessage = error instanceof Error ? error : new Error('Failed to fetch models');
    yield* put(modelAction.fetchModelsFailure(errorMessage));
    console.error('Failed to fetch models:', error);
  }
};

export const watchFetchModels = function* () {
  yield* takeEvery(modelConstant.FETCH_MODELS_REQUEST, fetchModels);
};
